import { useState } from 'react';
import { jobAPI } from '../../../services/api';

// Extracted verbatim from JobManagement.js (Task 4). `isLoading` is a shared
// flag owned by the orchestrator — this hook receives `setIsLoading` and
// flips it exactly as the original inline function did. Do not give this
// hook its own loading flag; see task-4-brief.md.
export const useJobDashboard = ({ setIsLoading }) => {
  const [stats, setStats] = useState(null);

  const loadDashboardData = async () => {
    try {
      setIsLoading(true);
      const data = await jobAPI.getDashboardStats();
      setStats(data);
    } catch (error) {
      console.error('Error loading dashboard:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return { stats, loadDashboardData };
};
